// extracted by css-extract-rspack-plugin
export default {"box":"box-zyT3Qm","headerbox":"headerbox-qvekd_","footerbox":"footerbox-eWe5OE"};// extracted by css-extract-rspack-plugin
export default {"box":"box-zyT3Qm","headerbox":"headerbox-qvekd_","footerbox":"footerbox-eWe5OE"};